export const buildVoEInstructionsEmailBody = ({
  companyName,
  applicantName,
  pastEmployerName,
  recruiterEmail,
  companyPhone,
}: {
  companyName: string
  applicantName: string
  pastEmployerName: string
  recruiterEmail: string
  companyPhone: string
}) => `Hello,

We are reaching out from ${companyName} to request verification of employment for ${applicantName}, as required by FMCSA regulations (49 CFR §391.23).

Driver Name: ${applicantName}
Previous Employer: ${pastEmployerName}
Requested By: ${companyName}

Please complete this verification using the secure link below. You will log in with your email address and receive a one-time password.

Alternatively, you can complete the attached PDF and return it to ${recruiterEmail}.

We appreciate your prompt attention to this request. If you have any questions, please contact us at ${companyPhone}.

Thank you,
${companyName}`
